import React, { RefObject, useEffect, useState } from 'react';

import './TableData.scss';
import { IDocumentTable, TableColumn } from '@models/Forms/IForms';
import { MdEdit } from 'react-icons/md';
import TableForm from './ModalForms/TableForm';
import { IField } from '@models/IFormData';
import Tooltip from '../Tooltip';
import {
    isTableColumn,
    isTableColumnAbook,
    isTableColumnAutoComplete,
    isTableColumnCalc,
    isTableColumnDict,
} from '@utils/tableHelper';
import DataGrid from 'devextreme-react/data-grid';

export interface EditRowMultiButtonProps {
    column: TableColumn;
    onSubmit: (data: IField[]) => Promise<void>;
    canEditRowMulti: (column: TableColumn) => boolean;
    getParentFields: () => IField[];
    docId?: string;
    table: IDocumentTable;
    gridRef?: RefObject<DataGrid | null>;
}

const EditRowMultiButton: React.FC<EditRowMultiButtonProps> = ({
    column,
    onSubmit,
    canEditRowMulti,
    getParentFields,
    docId,
    table,
    gridRef,
}: EditRowMultiButtonProps) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const activated = React.useRef(false);
    const [selectedRowArray, setSelectedRowArray] = useState<any>([{ '|NUM': '-1' }]);

    let tableForm = { ...table };
    tableForm.tableColumn = isTableColumn(column)
        ? [{ ...column, changes: { change: [] }, visibilityRules: '', readonly: '', required: '' }]
        : [];
    tableForm.tableColumnAbook = isTableColumnAbook(column)
        ? [{ ...column, changes: { change: [] }, visibilityRules: '', readonly: '', required: '' }]
        : [];
    tableForm.tableColumnAutoComplete = isTableColumnAutoComplete(column)
        ? [{ ...column, changes: { change: [] }, visibilityRules: '', readonly: '', required: '' }]
        : [];
    tableForm.tableColumnDict = isTableColumnDict(column)
        ? [{ ...column, changes: { change: [] }, visibilityRules: '', readonly: '', required: '' }]
        : [];
    tableForm.tableColumnCalc = isTableColumnCalc(column)
        ? [{ ...column, changes: { change: [] }, visibilityRules: '', readonly: '', required: '' }]
        : [];
    tableForm.customForm = '';

    const onClick = async (e: any) => {
        e.preventDefault();
        e.stopPropagation();

        const selectedRowsData = gridRef?.current?.instance.getSelectedRowsData();

        if (canEditRowMulti(column) && selectedRowsData && selectedRowsData?.length > 0) {
            // Данные строки берем из первой выделенной строки.
            // Проверка на одинаковость FormValues у выбранных строк уже была выполнена ранее.
            setSelectedRowArray([selectedRowsData[0]]);

            setShowModal(!showModal);
        }
    };

    const onSubmitHandler = async (data: IField[]) => {
        await onSubmit(data);
        if (activated.current) {
            setShowModal(!showModal);
        }
    };

    useEffect(() => {
        activated.current = true;
        return () => {
            activated.current = false;
        };
    }, []);

    return (
        <>
            <Tooltip openDelay={100} background="black" position="bottom">
                <MdEdit size="16" onClick={onClick} />
                Редактировать значение колонки в выбранных строках
            </Tooltip>

            {showModal && (
                <TableForm
                    table={tableForm}
                    docId={docId}
                    title={`Значение для колонки`}
                    isEdit={true}
                    onClose={() => {
                        setShowModal(!showModal);
                    }}
                    onSubmit={onSubmitHandler}
                    submitButtonCaption="Применить"
                    getParentFields={getParentFields}
                    rowIndex={0}
                    rowArray={selectedRowArray}
                    disablePagination={true}
                />
            )}
        </>
    );
};

export default EditRowMultiButton;
